'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { getMarginLeft } from '../../utils/toolbar';
import withDisabledContext from '../hoc/withDisabledContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledControl = styled.div.withConfig({
  displayName: "Control__StyledControl",
  componentId: "jhlaul-0"
})(["flex-shrink:0;margin-left:", "px;"], props => props.marginLeft);
class Control extends Component {
  constructor(props) {
    super();
    this.updateControlRect = () => {
      const {
        updateControlRect
      } = this.props;
      if (this.el && typeof updateControlRect === 'function') {
        const domRect = this.el.getBoundingClientRect();
        updateControlRect({
          width: domRect.width,
          marginLeft: this.state.marginLeft
        });
      }
    };
    this.state = {
      marginLeft: getMarginLeft(props.prevControlType || null)
    };
  }
  componentDidMount() {
    this.updateControlRect();
  }
  componentDidUpdate(prevProps) {
    const {
      prevControlType,
      menuItems
    } = this.props;
    if (!menuItems && prevProps.prevControlType !== prevControlType) {
      this.setState({
        marginLeft: getMarginLeft(prevControlType || null)
      }, this.updateControlRect);
    }
  }
  render() {
    const {
      disabled,
      contextualNodeAttributes,
      menuItems
    } = this.props;
    return /*#__PURE__*/_jsx(StyledControl, {
      marginLeft: this.state.marginLeft,
      children: /*#__PURE__*/_jsx("div", {
        ref: el => this.el = el,
        children: this.props.render({
          disabled,
          contextualNodeAttributes,
          menuItems
        })
      })
    });
  }
}
export default withDisabledContext(Control);
Control.propTypes = {
  render: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  prevControlType: PropTypes.string,
  updateControlRect: PropTypes.func,
  contextualNodeAttributes: PropTypes.object,
  menuItems: PropTypes.array
};